import { useEffect, useRef, useState } from "react";
import ModalForSettings from "../../Products/Components/ModalForSettings";
import ModalForHiddenProducts from "../../Products/Components/ModalForHiddenProducts";

function A2WFilterBar(props) {
  const fileInputRef = useRef(null);
  const [modalSetting, setModalSetting] = useState("");
  const [searchText, setSearchText] = useState(props.filters.hasOwnProperty("search") ? props.filters.search : "");
  const [showHiddenProducts, setShowHiddenProducts] = useState(false);
  const [moreSettingsModal, setMoreSettingsModal] = useState(false);
  const [saveFiltersSlot, setSaveFiltersSlot] = useState(1);
  const [savedFiltersA2W, setSavedFiltersA2W] = useState(localStorage.getItem('saveFiltersA2W'));
  const [nameSavedFiltersA2W, setNameSavedFiltersA2W] = useState(localStorage.getItem('name_saveFiltersA2W'));
  const [manualRender, setManualRender] = useState(15);
  const [categories, setCategories] = useState({
    "Kitchen & Dining": false,
    "Beauty & Personal Care": false,
    "Toys & Games": false,
    "Office Products": false,
    "Home & Kitchen": false,
    "Baby": false,
    "Unique Finds": false,
    "Sports & Outdoors": false,
    "Patio, Lawn & Garden": false,
    "Arts, Crafts & Sewing": false,
    "Tools & Home Improvement": false,
    "Automotive": false,
    "Industrial & Scientific": false,
    "Video Games": false,
    "Health & Household": false,
    "Our Brands": false,
    "Cell Phones & Accessories": false,
    "Pet Supplies": false,
    "Books": false,
    "Musical Instruments": false,
    "Clothing, Shoes & Jewelry": false,
    "Grocery & Gourmet Food": false,
    "Climate Pledge Friendly": false,
    "Electronics": false,
    "Amazon Renewed": false,
    "Amazon Devices & Accessories": false,
    "Computers & Accessories": false,
    "Appliances": false,
    "CDs & Vinyl": false,
    "Software": false,
    "Handmade Products": false,
    "Collectible Coins": false,
    "Movies & TV": false,
    "Camera & Photo Products": false,
  });
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);

  const handleSaveFilters = (filters) => {
    localStorage.setItem(`saveFiltersA2W${saveFiltersSlot !== 1 ? saveFiltersSlot : ""}`, JSON.stringify(filters));
    setSavedFiltersA2W(JSON.stringify(filters));
    setManualRender(mr => mr + 1);
  };

  const handleLoadFilters = () => {
    const savedFilters = localStorage.getItem(`saveFiltersA2W${saveFiltersSlot !== 1 ? saveFiltersSlot : ""}`);
    if (savedFilters) {
      props.setFilters(JSON.parse(savedFilters));
    }
  };

  const downloadFilters = () => {
    const filters = JSON.stringify(props.filters);
    const blob = new Blob([filters], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "filters.json";
    a.click();
    URL.revokeObjectURL(url);
  };

  const loadFiltersFromFile = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const filters = JSON.parse(e.target.result);
        props.setFilters(filters);
        handleSaveFilters(filters);
      } catch (error) {
        alert("Invalid file format. Please upload a valid JSON file.");
      }
    };
    reader.readAsText(file);
  };

  const parseFiltersJSON = (filters) => {
    return filters.replace("{", "").replace("}", "").replaceAll('"', '').replaceAll(',', ', ').replace("search:,", "").replace("moq:[-1, -1],", "").toLowerCase().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).replace(":", ": ")).join(' ').replaceAll("-1", "N/A");
  };

  const setNameSavedFiltersA2WLocal = (name) => {
    localStorage.setItem(`name_saveFiltersA2W${saveFiltersSlot !== 1 ? saveFiltersSlot : ""}`, name);
  };

  useEffect(() => {
    setSavedFiltersA2W(localStorage.getItem(`saveFiltersA2W${saveFiltersSlot !== 1 ? saveFiltersSlot : ""}`));
    setNameSavedFiltersA2W(localStorage.getItem(`name_saveFiltersA2W${saveFiltersSlot !== 1 ? saveFiltersSlot : ""}`));
  }, [saveFiltersSlot]);

  const styles = {
    moreFilters: {
      textDecoration: "underline",
      width: "auto",
      cursor: "pointer",
      fontSize: "1.05vw",
      fontWeight: "500",
      display: "table-cell",
      verticalAlign: "middle",
      color: "SlateBlue"
    },
    textAreaP: {
      width: "60%",
      overflowY: "scroll",
      backgroundColor: "rgba(0,0,0,0.2)",
      minHeight: manualRender + "px",
      maxHeight: "10vh",
      textAlign: "center",
      margin: "auto",
      marginTop: "5px"
    }
  };

  return (
    <div
      className="columns is-centered is-multiline is-mobile"
      style={{
        textAlign: "center",
        marginTop: props.isMobile ? "1vh" : "5vh",
        marginLeft: !props.isMobile && "-10vw",
        marginRight: !props.isMobile ? "-6vw" : "-2vw",
        verticalAlign: "middle",
      }}
    >
      <div className="column is-2-desktop is-6-mobile">
        <div className="field has-addons">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width={props.isMobile ? "17vw" : "3.5vw"}
            height={"4.4vh"}
            viewBox="0 0 120.000000 120.000000"
            preserveAspectRatio="xMidYMid meet"
            style={{ cursor: "pointer" }}
            onClick={() => window.location.reload()}
          >
            <g
              transform="translate(0.000000,111.000000) scale(0.0900000,-0.086000)"
              fill="#000000"
              stroke="none"
            >
              <path d="M813 1266 c-77 -25 -153 -94 -183 -167 l-12 -29 -247 0 c-266 0 -291 -5 -291 -53 0 -27 -6 -17 184 -277 l151 -205 5 -253 c5 -236 6 -255 24 -268 32 -23 50 -17 142 51 63 46 92 74 101 97 7 20 12 97 12 199 l1 166 58 82 57 82 51 -6 c30 -3 74 1 108 10 270 71 306 430 56 555 -56 28 -157 36 -217 16z m182 -82 c85 -40 145 -146 129 -231 -33 -185 -248 -257 -378 -127 -107 107 -78 286 56 353 52 26 145 28 193 5z m-384 -251 c8 -64 45 -130 99 -176 l40 -34 -18 -24 c-11 -13 -40 -55 -66 -92 l-46 -68 0 -178 0 -179 -55 -41 c-30 -22 -57 -41 -60 -41 -3 0 -5 96 -5 213 0 185 -2 217 -18 247 -10 19 -82 122 -160 228 -78 106 -142 195 -142 198 0 2 96 3 213 2 l212 -3 6 -52z" />
              <path d="M800 1070 c-8 -15 -5 -25 20 -53 l29 -34 -24 -23 c-28 -26 -32 -61 -11 -79 17 -14 41 -5 70 28 l19 21 34 -30 c28 -25 38 -28 53 -20 27 15 25 39 -7 72 l-27 28 27 28 c29 31 34 51 15 70 -18 18 -33 15 -68 -14 l-31 -27 -28 27 c-32 31 -56 33 -71 6z" />
            </g>
          </svg>

          <div className="control">
            <input
              className="input searchproduct"
              type="text"
              style={{
                backgroundColor: "rgb(179,127,170)",
                color: "white",
                fontSize: props.isMobile ? "1.9vh" : ".95vw",
              }}
              placeholder={"Search Product"}
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  props.setFilters((filters) => ({
                    ...filters,
                    search: searchText,
                  }));
                }
              }}
            />
          </div>
          <div className="control">
            <button
              className="button is-success"
              style={{
                color: "white",
                fontSize: props.isMobile ? "1.9vh" : ".95vw",
              }}
              onClick={() => {
                props.setFilters((filters) => ({
                  ...filters,
                  search: searchText,
                }));
              }}
            >
              <i className="fa fa-search" />
            </button>
          </div>
        </div>
      </div>
      <div className="column is-1-desktop is-3-mobile">
        <details className="selectlight selectdropdown" style={{ fontSize: props.isMobile ? "1.9vh" : ".85vw" }}>
          <div className="modal-background" onClick={(e) => {
            if (categoryDropdownOpen) {
              props.setFilters((filters) => ({
                ...filters,
                category: Object.keys(categories).sort().filter(key => categories[key] === true),
              }))
              if (Object.keys(categories).sort().filter(key => categories[key] === true).length === 0) {
                let tempFilters = { ...props.filters }
                delete tempFilters['category']
                props.setFilters(tempFilters)
              }
            }
            setCategoryDropdownOpen(before => !before);; e.target.parentElement.open = false
          }} style={{ zIndex: 9, height: "200vh", backgroundColor: "transparent" }}></div>
          <summary onClick={() => {
            if (categoryDropdownOpen) {
              props.setFilters((filters) => ({
                ...filters,
                category: Object.keys(categories).sort().filter(key => categories[key] === true),
              }))
              if (Object.keys(categories).sort().filter(key => categories[key] === true).length === 0) {
                let tempFilters = { ...props.filters }
                delete tempFilters['category']
                props.setFilters(tempFilters)
              }
            }
            setCategoryDropdownOpen(before => !before);
          }} style={{ backgroundColor: categoryDropdownOpen && "green", color: categoryDropdownOpen && "white", zIndex: 10, position: "relative" }}>{categoryDropdownOpen ? "Save" : "Category"}</summary>
          <ul>
            <li key={"SelectAll"}>
              <label><input type="checkbox" name={"SelectAll"} value={"SelectAll"}
                onChange={(e) => {
                  setCategories((prevCat) => {
                    const updatedCategories = { ...prevCat };

                    Object.keys(updatedCategories).forEach((key) => {
                      updatedCategories[key] = e.target.checked;
                    });

                    return updatedCategories;
                  })
                }} /> {Object.values(categories).every(value => value === true) ? "Unselect All" : "Select All"}</label>
            </li>
            {Object.keys(categories).sort().map((category, index) => {
              return <li key={index}>
                <label><input type="checkbox" name={category} value={category} checked={categories[category]}
                  onChange={(e) => { setCategories({ ...categories, [category]: e.target.checked }) }} /> {category}</label>
              </li>;
            })}
          </ul>
        </details>
      </div>
      <div className="column is-1-desktop is-3-mobile">
        <button
          className="button is-rounded lightbutton"
          onClick={() => setModalSetting("bsr")}
          style={{
            border:
              props.filters &&
              props.filters.hasOwnProperty("bsr") &&
              "3px solid rgb(72,199,142)",
          }}
        >
          AZ BSR
        </button>
      </div>
      <div className="column is-1-desktop is-3-mobile">
        <button
          className="button is-rounded lightbutton"
          onClick={() => setModalSetting("az_price")}
          style={{
            border:
              props.filters &&
              props.filters.hasOwnProperty("az_price") &&
              "3px solid rgb(72,199,142)",
          }}
        >
          AZ Price
        </button>
      </div>
      <div className="column is-1-desktop is-3-mobile">
        <button
          className="button is-rounded lightbutton"
          onClick={() => setModalSetting("walmart_price")}
          style={{
            border:
              props.filters &&
              props.filters.hasOwnProperty("walmart_price") &&
              "3px solid rgb(72,199,142)",
          }}
        >
          {!props.isMobile ? "Walmart Price" : "W Price"}
        </button>
      </div>
      <div className="column is-1-desktop is-3-mobile">
        <button
          className="button is-rounded lightbutton"
          onClick={() => setModalSetting("gross_profit")}
          style={{
            border:
              props.filters &&
              props.filters.hasOwnProperty("gross_profit") &&
              "3px solid rgb(72,199,142)",
          }}
        >
          {!props.isMobile ? "Gross Profit" : "G Profit"}
        </button>
      </div>
      <div className="column is-1-desktop is-3-mobile" style={{ width: "auto" }}>
        <button
          className="button is-rounded lightbutton"
          onClick={() => setModalSetting("roi")}
          style={{
            border:
              props.filters &&
              props.filters.hasOwnProperty("roi") &&
              "3px solid rgb(72,199,142)",
            width: "auto"
          }}
        >
          ROI
        </button>
      </div>
      {!props.isMobile && (
        <div className="column is-1-desktop" style={{ padding: "0", width: "auto", display: "table", verticalAlign: "middle" }}>
          <span id="more-settings-modal-title" onClick={() => setMoreSettingsModal(true)} style={styles.moreFilters}>More</span>
          <div id="more-settings-modal" className={"modal" + (moreSettingsModal ? " is-active" : "")} >
            <div className="modal-background" onClick={() => setMoreSettingsModal(false)} />
            <div className="modal-content" style={{ width: props.isMobile ? "90vw" : "30vw" }}>
              <div className="box" style={{ textAlign: "center" }}>
                <p style={{ fontSize: props.isMobile ? "2.5vh" : "1.1vw" }}>Advanced Settings</p>
                <br />
                <br />
                <div style={{ border: "1px solid gray", padding: "15px 0px", borderRadius: "10px" }}>
                  <div style={{ marginBottom: "10px" }}>
                    Switch Filters: &emsp;
                    <button style={{ backgroundColor: "transparent", borderRadius: "20px", cursor: saveFiltersSlot !== 1 && "pointer" }} disabled={saveFiltersSlot === 1} onClick={() => setSaveFiltersSlot(1)}>1</button>&emsp;
                    <button style={{ backgroundColor: "transparent", borderRadius: "20px", cursor: saveFiltersSlot !== 2 && "pointer" }} disabled={saveFiltersSlot === 2} onClick={() => setSaveFiltersSlot(2)}>2</button>&emsp;
                    <button style={{ backgroundColor: "transparent", borderRadius: "20px", cursor: saveFiltersSlot !== 3 && "pointer" }} disabled={saveFiltersSlot === 3} onClick={() => setSaveFiltersSlot(3)}>3</button>&emsp;
                    <button style={{ backgroundColor: "transparent", borderRadius: "20px", cursor: saveFiltersSlot !== 4 && "pointer" }} disabled={saveFiltersSlot === 4} onClick={() => setSaveFiltersSlot(4)}>4</button>&emsp;
                    <button style={{ backgroundColor: "transparent", borderRadius: "20px", cursor: saveFiltersSlot !== 5 && "pointer" }} disabled={saveFiltersSlot === 5} onClick={() => setSaveFiltersSlot(5)}>5</button>&emsp;
                    <button style={{ backgroundColor: "transparent", borderRadius: "20px", cursor: saveFiltersSlot !== 6 && "pointer" }} disabled={saveFiltersSlot === 6} onClick={() => setSaveFiltersSlot(6)}>6</button>&emsp;
                    <button style={{ backgroundColor: "transparent", borderRadius: "20px", cursor: saveFiltersSlot !== 7 && "pointer" }} disabled={saveFiltersSlot === 7} onClick={() => setSaveFiltersSlot(7)}>7</button>
                  </div>
                  <div style={{ display: "flex", margin: 'auto', justifyContent: "center", gap: '10px' }}>
                    <button
                      className="button is-rounded lightbutton is-success"
                      onClick={() => handleSaveFilters(props.filters)}
                      style={{ width: "30%" }}
                    >
                      Save Filters
                    </button>
                    <button
                      className="button is-rounded lightbutton"
                      onClick={handleLoadFilters}
                      style={{ width: "30%" }}
                    >
                      Load Filters
                    </button>
                  </div>
                  <p style={styles.textAreaP}>{savedFiltersA2W !== null ? parseFiltersJSON(savedFiltersA2W) : ""}</p>
                  <input render={saveFiltersSlot} placeholder={nameSavedFiltersA2W ?? "Name the filters"} style={{ marginTop: "8px" }} onBlur={(e) => { setNameSavedFiltersA2WLocal(e.target.value); e.target.value = "" }} />
                  <br />
                  <br />
                  <div style={{ display: "flex", margin: 'auto', justifyContent: "center", gap: '10px' }}>
                    <button
                      className="button is-rounded lightbutton is-success"
                      onClick={downloadFilters}
                      style={{ width: "auto" }}
                    >
                      Download Filters as file
                    </button>
                    <input type="file" accept=".json" onChange={loadFiltersFromFile} style={{ display: "none" }} ref={fileInputRef} />
                    <button
                      className="button is-rounded lightbutton"
                      onClick={() => fileInputRef.current.click()}
                      style={{ width: "auto" }}
                    >
                      Load Filters from file
                    </button>
                  </div>
                </div>
                <br />
                <br />
                <div className="columns is-mobile is-centered">
                  <button
                    className="button is-rounded is-danger"
                    style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw" }}
                    onClick={() => setMoreSettingsModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="column is-1-desktop is-3-mobile is-offset-2" style={{ marginLeft: props.isMobile ? "0" : "1vw" }}>
        <button
          className="button is-rounded darkbutton"
          onClick={() => setShowHiddenProducts(true)}
        >
          {!props.isMobile ? "My Hidden Products" : "Hidden"}
        </button>
      </div>

      <ModalForSettings
        filters={props.filters}
        setFilters={props.setFilters}
        modalSetting={modalSetting}
        setModalSetting={setModalSetting}
        isMobile={props.isMobile}
        supplierType={props.supplierType}
      />
      {showHiddenProducts && <ModalForHiddenProducts
        isMobile={props.isMobile}
        setShowHiddenProducts={setShowHiddenProducts}
        showHiddenProducts={showHiddenProducts}
      />}
    </div>
  );
}

export default A2WFilterBar;
